import { Wordmark } from '@/components/Wordmark'
import './Splash.css'

/** Shown until the first auth state and household snapshot arrive. Never an empty state. */
export function Splash() {
  return (
    <div className="splash" aria-busy="true" aria-live="polite">
      <Wordmark className="splash__name" />
      <span className="sr-only">Loading</span>
    </div>
  )
}
